export type OTPData = {
  OTP: string;
  userId: string;
  time: string;
};
export interface SendMessageDto {
  phone?: string | null;
  email?: string | null;
  message: string;
  subject: string;
  consumerId?: string;
  isSentToGuarantor?: boolean;
}

// adds possibility of sending multiple text messages and just one email
export interface SendSeparateTextsAndEmailDto {
  consumerId?: string;
}

export enum ResponseStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export interface ResponseDto {
  status: number;
  responseStatus: ResponseStatus;
  error?: {
    errorCode: string;
    message: string;
  };
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  data: any;
}
